import CallBackForm from "../CallBackForm";
import WhatsAppForm from "../WhatsAppForm";
import { getImgUrl } from "../../../../utills";
import { WHATSAPP_BTN_ID } from "../../constant";
import { ALT_KEY, CLOSE_ICN } from "../../../../GlobalConstant/image";

import styles from "../HelpWidgetsFormModal/HelpWidgetsFormModal.module.scss";

const HelpWidgetsFormModal = ({ onClose, type, configData }) => {

  const handleClose = () => {
    onClose?.()
  }

  return <div className={`${styles.formContainer} ${styles.open}`}>
    <div type="button" className={styles['close-icn']} onClick={handleClose}>
      <img src={getImgUrl(CLOSE_ICN)} alt={ALT_KEY.CLOSE} />
    </div>
    {type === WHATSAPP_BTN_ID ? <WhatsAppForm whatsAppConfig={configData?.whatsAppConfig} /> : <CallBackForm formSchema={configData?.callBackConfig?.formField} />}
  </div>
};

export default HelpWidgetsFormModal;